export const MODULE = 'OVRS_REPORT';

export const GENERATE_OVRS_REPORT = `${MODULE}/GENERATE_OVRS_REPORT`;
export const GET_GENERATED_OVRS_LISTING = `${MODULE}/GET_GENERATED_OVRS_LISTING`;
export const CHECK_RECORDS = `${MODULE}/CHECK_RECORDS`;
export const DOWNLOAD_CSV = `${MODULE}/DOWNLOAD_CSV`;
export const PAYMENT_LIST = `${MODULE}/PAYMENT_LIST`;
export const AMNESTY_LIST = `${MODULE}/AMNESTY_LIST`;
export const EXPORTS_LIST = `${MODULE}/EXPORTS_LIST`;
export const GET_PREVIEW_LINK = `${MODULE}/get_preview_link`;
export const EXPORT_PAYMENTS = `${MODULE}/EXPORT_PAYMENTS`;
export const EXPORT_APPREHENSIONS = `${MODULE}/EXPORT_APPREHENSIONS`;

export const OVRS_TYPE = [
  { label: 'ENFORCER INCENTIVE REPORT', value: 'ENFORCER INCENTIVE REPORT' },
  { label: 'OVR INCENTIVE PAYROLL', value: 'OVR INCENTIVE PAYROLL' },
];

export const EXPORT_TYPE_OPTIONS = [
  { label: 'PAYMENTS', value: 'OVRS_PAYMENTS' },
  { label: 'APPREHENSIONS', value: 'OVRS_APPREHENSIONS' },
];
